import { render, staticRenderFns } from "./PermissionControls.vue?vue&type=template&id=1a4fcd9d&scoped=true&"
import script from "./PermissionControls.vue?vue&type=script&lang=js&"
export * from "./PermissionControls.vue?vue&type=script&lang=js&"
import style0 from "./PermissionControls.vue?vue&type=style&index=0&id=1a4fcd9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4fcd9d",
  null
  
)

export default component.exports